<template>
    <nav class="adjustment-tabs" aria-label="Inventory adjustment history">
        <router-link
            v-for="tab in tabs"
            :key="tab.to"
            :to="tab.to"
            class="adjustment-tab"
            :class="{ active: isActive(tab.to) }"
        >
            <i :class="tab.icon" aria-hidden="true"></i>
            <span>{{ tab.label }}</span>
        </router-link>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            tabs: [
                { label: "Quantity", to: "/inventory-adjustments/quantity", icon: "fas fa-boxes" },
                { label: "Cost", to: "/inventory-adjustments/cost", icon: "fas fa-file-invoice-dollar" },
                { label: "Price", to: "/inventory-adjustments/price", icon: "fas fa-tags" },
            ],
        }
    },
    methods: {
        isActive(path) {
            return this.$route.path === path || this.$route.path.startsWith(`${path}/`)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.adjustment-tabs {
    display: flex;
    gap: 4px;
    width: 100%;
    margin: 0 0 $sectionGap * 1.5;
    padding: 4px;
    overflow-x: auto;
    border: 1px solid $lightBorderColor;
    border-radius: $cardRadius;
    background: rgba($primaryColor, 0.04);
    scrollbar-width: thin;
}

.adjustment-tab {
    display: inline-flex;
    flex: 1 0 140px;
    align-items: center;
    justify-content: center;
    gap: 9px;
    min-height: 44px;
    padding: 9px 18px;
    border-radius: calc(#{$cardRadius} - 3px);
    color: rgba($textColor, 0.68);
    font-weight: 600;
    text-decoration: none;
    transition: background-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.adjustment-tab:hover,
.adjustment-tab:focus-visible {
    color: $primaryColor;
    background: rgba($primaryColor, 0.07);
    text-decoration: none;
}

.adjustment-tab.active {
    color: white;
    background: $primaryColor;
    box-shadow: 0 3px 9px rgba($primaryColor, 0.2);
}

@media (max-width: 640px) {
    .adjustment-tab {
        flex-basis: 118px;
        padding-inline: 13px;
    }
}
</style>
